import { getToken, resetState } from "../utils/index";

export default {
  namespaced: true,
  state: {
    error: null,
    loading: false,
    initialLoad: true,
    accountTransactions: {
      data: [],
    },
    accountOverview: {},
  },
  mutations: {
    GET_ACCOUNT_TRANSACTIONS_START: (state) => {
      state.loading = true;
    },
    GET_ACCOUNT_TRANSACTIONS_FAILED: (state, error) => {
      state.loading = false;
      state.error = error;
    },
    GET_ACCOUNT_TRANSACTIONS_SUCCESS: (state, accountTransactions) => {
      state.loading = false;
      state.initialLoad = false;
      state.accountTransactions = accountTransactions;
      console.log(accountTransactions);
    },
    GET_ACCOUNT_OVERVIEW_START: (state) => {
      state.loading = true;
    },
    GET_ACCOUNT_OVERVIEW_FAILED: (state, error) => {
      state.loading = false;
      state.error = error;
    },
    GET_ACCOUNT_OVERVIEW_SUCCESS: (state, accountOverview) => {
      state.loading = false;
      state.accountOverview = accountOverview;
      console.log(accountOverview);
    },
  },
  actions: {
    async getAccountTransactions({ commit }, payload) {
      const config = {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      try {
        commit("GET_ACCOUNT_TRANSACTIONS_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/transactions?type=account&start=${payload.startDate}&end=${payload.endDate}&show=20`,
          config
        );
        const data = await response.json();
        commit("GET_ACCOUNT_TRANSACTIONS_SUCCESS", data);
        if (response && response.status >= 400 && response.status < 405) {
          resetState();
          return false;
        }

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }
      } catch (err) {
        commit("GET_ACCOUNT_TRANSACTIONS_FAILED", err);
      }
    },
    async getAccountOverview({ commit }, payload) {
      const config = {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      try {
        commit("GET_ACCOUNT_OVERVIEW_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/transactions/overview?type=account&start=${payload.startDate}&end=${payload.endDate}`,
          config
        );
        const data = await response.json();
        commit("GET_ACCOUNT_OVERVIEW_SUCCESS", data);
        if (response && response.status >= 400 && response.status < 405) {
          resetState();
          return false;
        }

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }
      } catch (err) {
        commit("GET_ACCOUNT_OVERVIEW_FAILED", err);
      }
    },
  },
};
